import { gql } from '@apollo/client';
import { getCartQueryString, getShortTextLabelsQueryString } from './utils';

export const getMangeOrderCollection = gql`
	query getVignettesOrderManagementCollection($lang: String) {
		vignettesOrderManagementCollection(locale: $lang, limit: 1) {
			items {
				${getCartQueryString()}
				formData {
					orderNumber(locale: $lang)
				}
				helpDrawers: helpDrawersCollection(locale: $lang, limit: 5) {
					items {
						id
						helpDrawerTitle(locale: $lang)
					}
				}
				hintMessages: hintMessagesCollection(locale: $lang, limit: 10) {
					items {
						id
						tip(locale: $lang)
						message(locale: $lang) {
							json
						}
					}
				}
				teasers: teasersCollection(locale: $lang, limit: 4) {
                    items {
                        headline(locale: $lang)
                        content(locale: $lang) {
                            json
                        }
                        buttonLabel (locale: $lang)
                        buttonLink
                        image
                    }
                }
				${getShortTextLabelsQueryString([
					'headlineIntro',
					'normalProducts',
					'flexServices',
					'flexPaymentDetails',
					'flexPaymentMethod',
					'cancel',
					'cancelOrderLabel',
					'cancelOverlayText',
					'cancelationWithServiceFeeText',
					'cancelFlexOverlayText',
					'flexCanceledText',
					'refundLabel',
					'confirmCancelation',
					'partialRefundText',
					'originalPrice',
					'userFee',
					'cancelFlexService',
					'showTrips',
					'untilRevoked',
					'teaserHeadline',
					'showFurtherOrder',
					'updatePaymentMethod',
				])}
			}
		}
	}
`;
